import { ISubPhoto, ITowVehicle } from '../interfaces';

export class TowVehicle implements ITowVehicle {
  year?: number;
  make?: string;
  model?: string;
  licensePlate?: string;
  length?: number; // ft
  photo?: ISubPhoto;

  constructor(data?: ITowVehicle) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: ITowVehicle): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
